const initialState = {
    isModalVisible: false,
  };
  
  const tierModalReducer = (state = initialState, action) => {
    switch (action.type) {
      case "SHOW_ADD_TIER_MODAL":
        return { ...state, isModalVisible: true };
  
      case "HIDE_ADD_TIER_MODAL":
        return { ...state, isModalVisible: false };
  
      default:
        return state;
    }
  };
  
  export default tierModalReducer;
  